import { AdminPreviewPathProvider } from '@contexts/PathContext'
import { usePreviousRoute } from '@hooks/usePreviousRoute'
import { AppLayout } from '@layouts/AppLayout'
import { PathContent } from '@components/enrollments/paths/PathContent'

/**
 * Visão do produtor sobre o combo. Mesma tela da trilha do aluno, sem
 * enrollmentId na URL: a trilha vem de adminPreviewPath em vez da matrícula.
 */
export default function AdminViewPath() {
  const { backLabel } = usePreviousRoute()

  return (
    <AdminPreviewPathProvider>
      <AppLayout
        backRoute={{
          label: backLabel,
        }}
        backgroundColor="$bg-chrome"
        hasPaddingBottom={false}
      >
        <PathContent />
      </AppLayout>
    </AdminPreviewPathProvider>
  )
}
